import { render, staticRenderFns } from "./ApartmentIndex.vue?vue&type=template&id=e184f24c"
import script from "./ApartmentIndex.vue?vue&type=script&lang=js"
export * from "./ApartmentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports